import {EntityData, ListEntityData} from 'common/api/entities'
import {LabelValue, ReloadableSelector} from 'common/components/reloadable/ReloadableSelector'

interface EntitySelectorProps {
    value?: number | number[]
    onChange?: (value?: number | number[]) => void
    searchEntities: (search: string, page: number, size: number) => Promise<ListEntityData>
    loadEntity: (id: number) => Promise<EntityData>
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
    errorText?: string
    multiple?: boolean
}

export const EntitySelector = (
    {
        value,
        onChange,
        searchEntities,
        loadEntity,
        style,
        placeholder,
        disabled,
        errorText,
        multiple
    }: EntitySelectorProps
) => {

    const internalLoadValues = (ids: number[]) => {
        if (!ids.length) return Promise.resolve([])
        if (multiple) {
            return Promise
                .all(ids.map(id => loadEntityWrapper(id)))
                .then(list => list.filter(Boolean) as LabelValue<number>[])
        } else {
            return loadEntityWrapper(ids[0]).then(v => v ? [v] : [])
        }
    }

    const loadEntityWrapper = (id: number) => {
        return loadEntity(id).then(item => item.data && {value: item.data.id, label: item.data.name})
    }

    return (
        <ReloadableSelector
            value={value}
            onChange={(value) => onChange && onChange(value)}
            size={20}
            style={style}
            loadValues={internalLoadValues}
            loadOptions={(search, _current, page, size) =>
                searchEntities(search, page, size)
                    .then(item =>
                            item.data && item.data.map(item => item.data && {
                                value: item.data.id,
                                label: item.data.name
                            })
                    )
            }
            placeholder={placeholder}
            disabled={disabled}
            errorText={errorText}
            multiple={!!multiple}
        />
    )
}